<template>
    <div class="flex w-full h-full justify-center items-center">
        <div class="lds-ripple h-20 w-20">
            <div class="sr-only">Please wait, content is loading...</div>
            <div class="h-full w-full rounded-full" aria-hidden="true"></div>
            <div class="h-full w-full rounded-full" aria-hidden="true"></div>
        </div>
    </div>
</template>

<script lang="ts">
export default {};
</script>

<style lang="scss" scoped>
@import "../../styles/components/spinners.scss";
// tailwind .h-full wins in specificity, but in the case our spinner component, we want .h-auto to win.
.h-auto {
    height: auto !important;
}
</style>
